import React from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import {
  backendRegisterAgent,
  frontendIntegration,
  authFlowMermaid,
  credentialStorage,
  errorHandling,
  registerWithRetry,
  refreshCredentials
} from './webrtcCodeBlocks';

const codeBlock = (code) => (
  <pre className="bg-gray-100 rounded p-2 text-xs overflow-x-auto mb-2"><code>{code}</code></pre>
);

const AgentRegistrationProcess = () => (
  <div className="min-h-screen bg-[#f6fbfa]">
    <Navbar />
    <Sidebar />
    <main className="lg:pl-32 pt-24 flex justify-center">
      <div className="w-full max-w-screen-md px-4 pb-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">🔐 Agent Registration Process</h1>
        <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Step-by-Step Registration Flow</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-2">
          <li><b>Backend Setup</b> 🏗️</li>
        </ol>
        {codeBlock(backendRegisterAgent)}
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-2" start="2">
          <li><b>Frontend Integration</b> 🎨</li>
        </ol>
        {codeBlock(frontendIntegration)}
        <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Security Best Practices 🔒</h2>
        <ul className="list-disc pl-6 text-sm text-gray-700 mb-2">
          <li>Never Expose Credentials
            <ul className="list-disc pl-6">
              <li>Store agent credentials securely in your backend</li>
              <li>Use secure headers for credential transmission</li>
              <li>Implement proper session management</li>
              <li>Use HTTPS for all API calls</li>
            </ul>
          </li>
          <li>Authentication Flow
            {codeBlock(authFlowMermaid)}
          </li>
          <li>Credential Storage
            {codeBlock(credentialStorage)}
          </li>
          <li>Error Handling
            {codeBlock(errorHandling)}
          </li>
        </ul>
        <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Registration States 📊</h2>
        <table className="min-w-full text-sm text-left mb-4">
          <thead>
            <tr className="border-b">
              <th className="pr-4 py-2 font-semibold">State</th>
              <th className="pr-4 py-2 font-semibold">Description</th>
              <th className="pr-4 py-2 font-semibold">What to Do</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b"><td className="pr-4 py-2">INITIALIZING</td><td className="pr-4 py-2">Client is starting up</td><td className="pr-4 py-2">Wait for <code>onReady</code></td></tr>
            <tr className="border-b"><td className="pr-4 py-2">READY</td><td className="pr-4 py-2">Nonce received</td><td className="pr-4 py-2">Call your backend to register</td></tr>
            <tr className="border-b"><td className="pr-4 py-2">REGISTERING</td><td className="pr-4 py-2">Registration in progress</td><td className="pr-4 py-2">Show loading state</td></tr>
            <tr className="border-b"><td className="pr-4 py-2">REGISTERED</td><td className="pr-4 py-2">Successfully registered</td><td className="pr-4 py-2">Initialize WebRTC</td></tr>
            <tr><td className="pr-4 py-2">FAILED</td><td className="pr-4 py-2">Registration failed</td><td className="pr-4 py-2">Show error, allow retry</td></tr>
          </tbody>
        </table>
        <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Common Registration Issues 🔍</h2>
        <ul className="list-disc pl-6 text-sm text-gray-700 mb-2">
          <li><b>Invalid Nonce</b>
            <ul className="list-disc pl-6">
              <li>Nonce expires after 5 minutes</li>
              <li>Solution: Request a new nonce by reinitializing TaarWebRTC</li>
            </ul>
          </li>
        </ul>
        <ul className="list-disc pl-6 text-sm text-gray-700 mb-2">
          <li><b>Rate Limiting</b>
            <ul className="list-disc pl-6">
              <li>Too many registration attempts</li>
              <li>Solution: Implement exponential backoff</li>
            </ul>
          </li>
        </ul>
        {codeBlock(registerWithRetry)}
        <ul className="list-disc pl-6 text-sm text-gray-700 mb-2">
          <li><b>Credential Expiration</b>
            <ul className="list-disc pl-6">
              <li>Credentials may expire</li>
              <li>Solution: Implement refresh mechanism</li>
            </ul>
          </li>
        </ul>
        {codeBlock(refreshCredentials)}
      </div>
    </main>
  </div>
);

export default AgentRegistrationProcess; 